// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantStockThresholdFormInputs from "./CatalogVariantStockThresholdFormInputs.res.js";
import * as CatalogVariantStockThresholdFormContainer from "./CatalogVariantStockThresholdFormContainer.res.js";

function CatalogVariantStockThresholdFormCard(props) {
  return JsxRuntime.jsx(CatalogVariantStockThresholdFormContainer.make, {
    children: JsxRuntime.jsx(Card.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(CatalogVariantStockThresholdFormInputs.make, {}),
        spaceTop: "normal"
      }),
      title: I18n.t("Stock control")
    }),
    variantId: props.variantId,
    maxStockThreshold: props.maxStockThreshold,
    minStockThreshold: props.minStockThreshold,
    stockOrderTriggerThreshold: props.stockOrderTriggerThreshold
  });
}

let make = React.memo(CatalogVariantStockThresholdFormCard);

export {
  make,
}
/* make Not a pure module */
